import { Fragment, useEffect, useState } from "react"
import { useParams, useLocation } from "react-router-dom"
import { Button, Col, DatePicker, Input, message, Modal, Row, Select, Space, Form } from "antd"
import { useForm } from "antd/lib/form/Form"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import { CheckImgs } from "../../../component/common/Imgs"
import _ from 'lodash'

import '../css/AddServicePerson.css'
import { color } from "echarts"

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 12 },
};

interface Prop {
    storeID?: string,
    onFinish?: () => void
}

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    deal_item_name: string // 签单套餐名称
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
}

interface room {
    room_type_id: string // 房型id，其他接口可能会用到
    room_type_name: string // 房型名称
    update_time: string // 更新时间
    create_user_name: string // 创建人
}

interface roomType {
    "room_id": string // 房间id
    "room_type_name": string // 房型名称
    "room_number": string // 房间号
    "check_in_start_day": string // 入住开始日期
    "check_in_end_day": string // 入住结束日期
    "check_in_days": string // 入住天数
    "occupy_room_list": {
        "check_in_user_name": string
        "check_in_phone": string
        "check_in_start_day": string
        "check_in_end_day": string
        "remark": string
    }[]
}

export default function (prop: Prop) {

    const [swiperVisible, setSiperVisible] = useState<boolean>(false)
    const [urls, setUrls] = useState<string[]>([])

    const param: { id: string } = useParams()
    const Location: any = useLocation()

    const [visible, setVisible] = useState<boolean>(false)
    const [clientData, setClientData] = useState<Client>()

    const [form] = useForm()
    const [form2] = useForm()
    const [currentID, setCurrentId] = useState<string>()

    const [roomTypeName, setRoomTypeName] = useState<room[]>([])
    const [roomWays, setRoomWays] = useState<{ direction: string | number, direction_name: any }[]>([])

    const [emps, setEmps] = useState<{
        employee_id: string, // 员工id，其他接口可能会用到
        user_name: string // 员工名称
    }[]>([])

    const [roomData, setRoomData] = useState<{
        one_room: roomType[],
        two_room: roomType[]
    }>({
        one_room: [], two_room: []
    })

    const [checkInStartDay, setCheckInStartDay] = useState<string>()
    const [checkInEndDay, setCheckInEndDay] = useState<string>()

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.id
            }

        }).then((res: any) => {
            if (res) {
                setClientData(res)
            }
        })
    }

    useEffect(() => {
        getClientInfo()

        // 根据门店 => 查房型
        baseAxiosNoInfo('/global/room_type_list_by_store', {
            params: {
                store_id: Location.state.check_in_store_id
            }
        }).then((res: any) => {
            res && setRoomTypeName(res)
        })

        // 查询朝向
        baseAxiosNoInfo('/global/room_direction_list_by_store', {
            params: {
                store_id: Location.state.check_in_store_id
            }
        }).then((res: any) => {
            res && setRoomWays(res)
        })
    }, [])

    useEffect(() => {
        // 查员工
        if (prop.storeID) {
            baseAxiosNoInfo('/global/employee_list_by_position', {
                params: {
                    position_number: '26,22',
                    department_id: prop.storeID
                }
            }).then((res: any) => {
                res && setEmps(res)
            })
        }
    }, [prop])

    // 提交
    const onFinish = () => {
        if (!currentID) {
            message.error('必须选择房间才能提交')
            return
        }

        if (form2.getFieldValue('minion_id')) {
            baseAxiosComplete.post('/keeper/check_in/detail/distribute_minion_and_room', {
                check_in_id: param.id,
                minion_id: form2.getFieldValue('minion_id'),
                room_id: currentID,
                check_in_start_day: checkInStartDay,
                check_in_end_day: checkInEndDay,
            }).then((res: any) => {
                if (res.status === 0) {
                    setVisible(false)
                    if (prop.onFinish) prop.onFinish()
                }
            })

        } else {
            message.error('必须选择管家')
        }
    }

    const onFetchRoom = () => {
        if (!form.getFieldValue('check_in_time')) {
            message.error('请选择入住日期')
            return
        }

        if (!form.getFieldValue('check_in_total_days')) {
            message.error('请填写入住天数')
            return
        }

        baseAxiosNoInfo('/keeper/check_in/detail/query_can_order_room', {
            params: {
                check_in_id: param.id,
                check_in_time: form.getFieldValue('check_in_time').format('YYYY-MM-DD'),
                check_in_total_days: form.getFieldValue('check_in_total_days'),
                room_type_id: form.getFieldValue('room_type_id'),
                direction: form.getFieldValue('direction'),
                floor: form.getFieldValue('floor'),
                has_window: form.getFieldValue('has_window')
            }

        }).then((res: any) => {
            if (res) {
                res && setRoomData(res)

                if (res.one_room.length === 0 && res.two_room.length === 0) {
                    message.warn('暂无可用房间数据')
                }

            } else {
                message.error('请填写正确的入住信息')
            }
        })
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 录入服务人员并排房 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>录入服务人员并排房</Button>
        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />

        <Modal zIndex={1} title="录入服务人员并排房" width={1200} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row>
                <Col span={6}>
                    <div>
                        <Space>
                            <p>客人姓名：</p>
                            <p>{clientData?.check_in_user_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>手机号码：</p>
                            <p>{clientData?.check_in_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>怀孕时期：</p>
                            <p>{clientData?.preg_status_desc}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预产期/分娩日：</p>
                            <p>{clientData?.expect_born_day}/{clientData?.actually_born_day}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>实际入住日期：</p>
                            <p>{clientData?.check_in_time}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预计出所日期：</p>
                            <p>{clientData?.check_out_time_init}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>实际出所日期：</p>
                            <p>{clientData?.check_out_time_finally}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>紧急联系人：</p>
                            <p>{clientData?.emergency_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>紧急联系人手机：</p>
                            <p>{clientData?.emergency_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>陪护人：</p>
                            <p>{clientData?.accompany_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>陪护人手机：</p>
                            <p>{clientData?.accompany_phone}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>预住总天数：</p>
                            <p>{clientData?.check_in_total_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>已入住天数：</p>
                            <p>{clientData?.check_in_already_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>剩余天数：</p>
                            <p>{clientData?.check_in_left_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>合同凭证：</p>
                            <p><Button onClick={() => {
                                setUrls(clientData?.deal_prov_pic_list.split(',') || [])
                                setSiperVisible(true)
                            }} size="small" >查看</Button></p>
                        </Space>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}><h3 style={{ color: 'red' }}>房间信息筛选</h3></Col>
                <Col span={24}>
                    <Form onFinish={onFetchRoom} form={form} {...formItemLayout} layout="inline">
                        <Col span={12} style={{ marginBottom: '15px' }}>
                            <Form.Item label="入住日期" name="check_in_time" >
                                <DatePicker style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col span={12} style={{ marginBottom: '15px' }}>
                            <Form.Item label="入住天数" name="check_in_total_days" >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} style={{ marginBottom: '15px' }}>
                            <Form.Item label="房间房型" name="room_type_id">
                                <Select virtual={false}>
                                    {roomTypeName.map(el =>
                                        <Option value={el.room_type_id} key={el.room_type_id}>
                                            {el.room_type_name}
                                        </Option>
                                    )
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12} style={{ marginBottom: '15px' }}>
                            <Form.Item label="房间朝向" name="direction">
                                <Select>
                                    {roomWays.map((el: any) => <Option key={el.direction} value={el.direction}>{el.direction_name}</Option>)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12} style={{ marginBottom: '15px' }}>
                            <Form.Item label="所在楼层" name="floor">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} style={{ marginBottom: '15px' }}>
                            <Form.Item label="是否带窗" name="has_window">
                                <Select>
                                    <Option value={0} >没有</Option>
                                    <Option value={1} >有窗</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24} style={{ marginBottom: '15px' }}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit">查询可预定房间</Button>
                            </Form.Item>
                        </Col>
                    </Form>
                </Col>
            </Row>

            <Row>
                <Form form={form2} style={{ width: '100%' }}>
                    <Col span={24} style={{ marginBottom: '15px' }}>
                        <Form.Item labelAlign="left" label="责任管家" name="minion_id" >
                            <Select style={{ width: '280px' }}>
                                {emps.map(el => <Option value={el.employee_id} key={el.employee_id}>{el.user_name}</Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Form>
            </Row>

            <div>
                <h4>一间房</h4>
                <div className="clear">
                    {roomData.one_room.map(el => <div className={el.room_id === currentID ? "room-items active" : "room-items"} style={{ width: 230, height: 240 }} onClick={() => {
                        setCurrentId(el.room_id)
                        setCheckInStartDay(el.check_in_start_day)
                        setCheckInEndDay(el.check_in_end_day)
                    }}>
                        <p>房型：{el.room_type_name}</p>
                        <p>房号：{el.room_number}</p>
                        <p>从{el.check_in_start_day}</p>
                        <p>到{el.check_in_end_day}</p>
                        <p>可住{el.check_in_days}天</p>

                        {el.occupy_room_list.length > 0 ?
                            <h3 style={{ color: 'red' }}>已预定客户</h3> : ''
                        }

                        {el.occupy_room_list.map(occupy =>
                            <div style={{ padding: '2px 5px' }}>
                                <p>{occupy.check_in_user_name}：{occupy.remark}</p>
                            </div>
                        )}
                    </div>)}
                </div>
            </div>

            <div>
                <h4>两间房</h4>
                <div className="clear">
                    {roomData.two_room.map(el => <div className={el.room_id === currentID ? "room-items active" : "room-items"} onClick={() => {
                        setCurrentId(el.room_id)
                        setCheckInStartDay(el.check_in_start_day)
                        setCheckInEndDay(el.check_in_end_day)
                    }}>
                        <p>房型：{el.room_type_name}</p>
                        <p>房号：{el.room_number}</p>
                        <p>从{el.check_in_start_day}</p>
                        <p>到{el.check_in_end_day}</p>
                        <p>可住{el.check_in_days}天</p>
                    </div>)}
                </div>
            </div>
        </Modal>
    </Fragment>
}